export function formatRelativeTime(timestamp) {
  const now = new Date();
  const updated = new Date(timestamp);
  const diffInSeconds = Math.floor((now - updated) / 1000);

  const intervals = [
    { label: 'second', seconds: 1 },
    { label: 'minute', seconds: 60 },
    { label: 'hour', seconds: 3600 },
    { label: 'day', seconds: 86400 },
    { label: 'week', seconds: 604800 },
    { label: 'month', seconds: 2592000 },
    { label: 'year', seconds: 31536000 }
  ];

  for (let i = intervals.length - 1; i >= 0; i--) {
    const { label, seconds } = intervals[i];
    const count = Math.floor(diffInSeconds / seconds);

    if (count >= 1) {
      if (label === 'second' && count === 1) return '1 second ago';
      if (label === 'minute' && count === 1) return '1 minute ago';
      if (label === 'hour' && count === 1) return '1 hour ago';
      if (label === 'day' && count === 1) return 'yesterday';
      if (label === 'week' && count === 1) return 'last week';
      if (label === 'month' && count === 1) return 'last month';
      if (label === 'year' && count === 1) return 'last year';
      return `${count} ${label}${count > 1 ? 's' : ''} ago`;
    }
  }

  return 'just now';
}